import { ApiResponseStats, UserStats } from '../../api/wager-api';

const MOCK_PALYER_STATS: UserStats = {
  nick: 'Jack',
  globalRank: 100,
  activeDays: 20,
  bestScore: {
    value: 50000,
    top: 100,
  },
  averageScore: {
    value: 9000,
    top: 85,
  },
  winRate: {
    value: 10600,
    top: 65,
  },
  completedRounds: {
    value: 50,
    top: 45,
  },
  wonRounds: {
    value: 20,
    top: 25,
  },
  drawnRounds: {
    value: 250,
    top: 5,
  },
  bestWinStreak: {
    value: 500,
    top: 0,
  },
  wonAmount: {
    value: 200,
    top: 100,
  },
};

export function getMockPlayerStats(): ApiResponseStats {
  return {
    status: 200,
    msg: 'User game Stats',
    data: MOCK_PALYER_STATS,
  };
}
